import { setChatPrefill } from '../chatContext/chatAppContextStore';
import { MCGRAW_HILL_DEMO_QUESTIONS } from './mcgrawHillScriptedAnswers';

/**
 * Puts a question in the composer. Cleared first, so pressing the same dot
 * again refills a box the presenter has since edited or emptied (the store
 * ignores a prefill equal to the current one).
 */
const prefillQuestion = (question: string) => {
  setChatPrefill(null);
  window.requestAnimationFrame(() => setChatPrefill(question));
};

/**
 * mcgraw-hill: the presenter's demo dots on the AI desktop. Each fills the
 * composer with one of the demo's questions, in order, without sending it.
 */
const McGrawHillDemoDots = () => (
  <div className="mcgraw-hill-demo-dots">
    {MCGRAW_HILL_DEMO_QUESTIONS.map((question, index) => (
      <button
        key={question}
        type="button"
        className="mcgraw-hill-demo-dots__dot"
        aria-label={`Demo question ${index + 1}`}
        onClick={() => prefillQuestion(question)}
      />
    ))}
  </div>
);

export default McGrawHillDemoDots;
